module.exports = __webpack_public_path__ + "static/media/naturaleza.d8c63954.svg";